export default "__VITE_ASSET__D_yB0ysc__"